function initMegaMenu() {
  const triggers = document.querySelectorAll('[data-mega-menu-trigger]');

  triggers.forEach((trigger) => {
    if (trigger.__initialized) return;
    trigger.__initialized = true;

    const item = trigger.closest('.custom-header__nav-item--mega');
    if (!item) return;

    const close = () => {
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    const toggle = () => {
      if (item.classList.contains('is-open')) {
        close();
      } else {
        open();
      }
    };

    trigger.addEventListener('click', (event) => {
      event.stopPropagation();
      toggle();
    });

    document.addEventListener('click', (event) => {
      if (!item.contains(event.target)) {
        close();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        trigger.focus();
      }
    });
  });
}

function initMobileMenu() {
  const menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');

  if (!menuTrigger || !menu || !overlay) return;
  if (menuTrigger.__initialized) return;
  menuTrigger.__initialized = true;

  const openMenu = () => {
    menu.classList.add('is-open');
    overlay.classList.add('is-open');
    menuTrigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  };

  const closeMenu = () => {
    menu.classList.remove('is-open');
    overlay.classList.remove('is-open');
    menuTrigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  menuTrigger.addEventListener('click', () => {
    if (menu.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Submenu accordion inside mobile drawer
  document.querySelectorAll('[data-mobile-submenu-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.custom-header__mobile-item');
      if (!item) return;
      const isOpen = item.classList.contains('is-open');
      trigger.setAttribute('aria-expanded', String(!isOpen));
      item.classList.toggle('is-open');
    });
  });
}

function initHeader() {
  initMegaMenu();
  initMobileMenu();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeader);
} else {
  initHeader();
}

document.addEventListener('shopify:section:load', initHeader);
